import React, { useEffect, useReducer, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ButtonGroup, Dropdown, DropdownMenu, Nav, NavDropdown, Overlay, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
import { ACTIONS, navSubMenuReducer, navMenuReducer } from "./NavMenuReducer";
import { useDispatch } from "react-redux";
import { RefreshSharp } from "@mui/icons-material";
import { useLocation, matchPath } from "react-router-dom";

// https://www.w3.org/WAI/ARIA/apg/patterns/menubar/examples/menubar-navigation/
const NavMenu = ({ subMenuButtonTitle, menuId, subMenuItems, align }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [displaySubMenu, setDisplaySubMenu] = useState(false);
  const [displayMenu, setDisplayMenu] = useState(false);
  
  const dropDownRef = useRef();
  
  const subMenuRef = useRef(null);
  const subMenuBtnRefs = useRef(new Map());

  const menuRef = useRef(null);
  const menuBtnRefs = useRef(new Map());

  const { pathname } = useLocation();
  const [menu, menusDispatch] = useReducer(navMenuReducer, {visible: false, trigger: ''});
  const [subMenus, subMenusDispatch] = useReducer(navSubMenuReducer, {});
  const [visibleSubMenu, setVisibleSubMenu] = useState(null);



    // Add listeners for escape key and tabbing
    // - Close search results dropdown on escape
    // - Keep focus trapped within floating search container when tabbing 
   

    const handleExternalClick = (event) => {
        console.log(menuId, 'handleExternalClick', menu, event);
        const currentFocus = document.activeElement;
        console.log("The user is focusing on: ", currentFocus.tagName);
        
        if(dropDownRef?.current){
            var c = getClosest(event.target, "#"+menuId);
            if(c!=null && c==false){
                console.log(menuId, "does not contain",dropDownRef.current, event.target);
                closeAll("click");
            }
            else{
                console.log(menuId, "contains",dropDownRef.current, event.target);
                
            }
        }
    };

  useEffect(()=>{
    if(subMenuItems!=null){
        menusDispatch({
            type: ACTIONS.ADD_MENU,
            visible: false
        })
    }
    if(subMenuItems!=null && subMenuItems.hasOwnProperty('subMenus') && subMenuItems.subMenus!=null){
        console.log(subMenuItems.subMenus);

        Object.entries(subMenuItems.subMenus).map(([k,value])=>{
            subMenusDispatch({
                type: ACTIONS.ADD_MENU,
                subMenuKey: k,
                subMenuItems: value.links,
                label: value.label,
                visible: false
            })
        })
    }
    getMenuClassNames();
    document.addEventListener("click", handleExternalClick);
    return () => {
        document.removeEventListener("click", handleExternalClick);
    }
  },[])

  useEffect(()=>{
    console.log(document.activeElement);
    
  },[document.activeElement])

    useEffect(()=>{
        setVisibleSubMenu(getVisibleSubMenu());
    },[subMenus])

    useEffect(()=>{
        console.log(menuId, "menu", menu);
        console.log(getActiveElementId());
    },[menu])

    const KEY_NAME_ESC = 'Escape';
    const KEY_EVENT_TYPE = 'keydown';

    const getActiveElementId = () => {
        var d = document.activeElement;
        if(d!=null){
            if(d.id !=null){
                return d.id;
            }
        }
        else{
            return null;
        }
    }

    const getActiveElementTag = () => {
        var d = document.activeElement;        
        console.log("The user is focusing on: ", d.tagName);

        if(d!=null){
            if(d.tagName !=null){
                return d.tagName;
            }
        }
        else{
            return null;
        }
    }

    

    const getClosest = (child,parentSelector) => {
        console.log(menuId, "getClosest",child,parentSelector);

        var i = child.closest(parentSelector);
        if(i!=null){
            return true;
        }
        return false;
    }

    const hideSubMenu = (trigger) => {
        subMenusDispatch({
            type: ACTIONS.SET_VISIBILITY,
            subMenuKey: visibleSubMenu,
            visible: false,
            trigger: trigger
        })
        if((subMenuBtnRefs.current.get(visibleSubMenu))){
            (subMenuBtnRefs.current.get(visibleSubMenu))?.focus();
        }
    }

    const setMenuVisibility = (show, trigger) => {
        menusDispatch({
            type: ACTIONS.SET_VISIBILITY,
            visible: show,
            trigger: trigger
        })
        if(show==false){
            subMenusDispatch({
                type: ACTIONS.SET_VISIBILITY,
                subMenuKey: visibleSubMenu,
                visible: false,
                trigger: trigger
            })
        }
    }

    const closeAll = (trigger) => {
        subMenusDispatch({
            type: ACTIONS.SET_VISIBILITY,
            subMenuKey: visibleSubMenu,
            visible: false,
            trigger: trigger
        })
        setMenuVisibility(false,trigger);
    }


    const getVisibleSubMenu = () => {
        var visibleMenu = null;
        Object.entries(subMenus).map(([k,value])=>{
            if(value.visible==true){
                visibleMenu = value.subMenuKey;
            }
        })
        // console.log(visibleSubMenu);
        return visibleMenu;
    }

    const isCurrentPage = (path) =>{
        var props = {
            
        };
        if(matchPath({ path: path }, pathname)){
            props["aria-current"]='page';
        }
        return props;
    }

  

    const handleLinkPress = (event) => {
        
        console.log(event);
        if(event.type=="click"){
            //event.preventDefault();
            closeAll("click");
            // Stop page scrolling down
            navigate(
                event.target.pathname
            );
        }
        else{
            if (event.key === ' ' || event.keyCode == 32 || event.key=="Enter") {
                //event.preventDefault();
                //event.stopPropagation();
                closeAll("click");
                navigate(
                    event.target.pathname
                );
            }
        }
    };

    const getMenuClassNames = () =>{
        console.log(align);
        var classes = "";
        if(align!=null){
            
            for (const [key, value] of Object.entries(align)) {
                console.log(`${key}: ${value}`);
                if(value=="start"){
                    classes = classes + ` end-${key}-auto`
                }
                else{
                    classes = classes + ` start-${key}-auto`
                }
                classes = classes + ` ${value}-${key}-0`;
            }
        }
        console.log(classes);
        return classes;
    }

    var showMenuTimer = null;
    var closeMenuTimer = null;
    var closeSubMenuTimer = null;

    const lastFocusedRef = useRef(null);
    let allowHover = true;

  const handleBlur = (e) => {
    // Stores the element that just lost focus
    lastFocusedRef.current = e.target;
    console.log(lastFocusedRef);
  };

  return (

        <Dropdown
            key={menuId}
            className={"topnav-dropdown " + menuId}
            id={menuId}
            ref={dropDownRef}
            onClick={(e)=>{
                console.log(menuId, "Dropdown - onClick", e, document.activeElement );
                if (e.detail === 0) {
                    console.log("Triggered by keyboard (Enter/Space)");
                }
                else{
                    if(getActiveElementTag() == 'A' && document.activeElement.hasAttribute('href')){
                        e.preventDefault();
                    }
                    else{
                        setMenuVisibility(menu.visible, "click");
                        
                        console.log(visibleSubMenu);
                        console.log(document.activeElement);

                        if(visibleSubMenu!=null){
                            var c = getClosest(e.target,("#" + visibleSubMenu));
                            console.log(c);
                            if(c==false && getActiveElementId()!="drop-toggle-subMenu"){
                                // closeSubMenuTimer = setTimeout(() => {
                                    subMenusDispatch({
                                        type: ACTIONS.SET_VISIBILITY,
                                        subMenuKey: visibleSubMenu,
                                        visible: false,
                                        trigger: "click"
                                    })
                                // }, 500);
                            }
                        }
                    }
                }
                
                
                
                
            }}
            onMouseLeave={(e)=>{
                console.log(e, "MOUSE LEAVE ENTIRE", document.activeElement);
                
                if(menu.visible==true && (menu.trigger == "hover" || getActiveElementTag()=="BODY")){
                    var c = getClosest(document.activeElement,"#"+menuId);
                    
                    if(c!=null && c==false){
                        console.log("Dropdown - mouseLeave - CLOSE ALL - timeout");
                        clearTimeout(closeMenuTimer);
                        closeMenuTimer = setTimeout(() => {
                            closeAll("hover");
                        }, 500);
                    }
                    else{
                        
                    }
                }
            }}
            
            onMouseEnter={(e)=>{
                console.log(e, "MOUSE ENTER ENTIRE", document.activeElement);
                

                if(menu.visible==false ){
                    var c = getClosest(document.activeElement,"#"+menuId);
                    
                    // if(c!=null && c==false){
                    //     console.log("Dropdown - mouseLeave - CLOSE ALL");
                    //     closeMenuTimer = setTimeout(() => {
                    //         closeAll("hover");
                    //     }, 400);
                    // }
                    // else{
                        
                    // }
                    setMenuVisibility(true, "hover");//menu.trigger);
                }
                else{
                    clearTimeout(closeMenuTimer);
                    console.log(e.target);
                    if(e.target.id=="drop-toggle"){

                    }
                }
            }}
            show={menu.visible}
            as={Nav.Item}
        >
            <Dropdown.Toggle id="drop-toggle" className="topNavMenuItem nav-link" data-bs-boundary="viewport" variant=""
                onMouseUp={(e)=>{
                    console.log(menuId,"Dropdown.Toggle - onMouseUp",document.target, e, menu);

                    if(menu.visible != true){
                        setMenuVisibility(true,"click");
                    }
                    else{
                        //if(menu.trigger=="hover"){
                            //setMenuVisibility(true,"click");
                        //}
                        //else{
                            setMenuVisibility(false,"click");
                        //}
                    }  
                }}
                onClick={(e)=>{
                    console.log("Dropdown.Toggle - onClick", e);
                    
                    var show = !menu.visible;
                    
                    if (e.detail === 0) {
                        console.log("Triggered by keyboard (Enter/Space)");

                        if(menu.visible==false){
                            setMenuVisibility(true,"click");
                        }
                        else{
                            setMenuVisibility(false,"click");
                        }
                        
                        const timer = setTimeout(() => {
                            if(show==true && menuRef!=null && menuRef.current!=null){
                                const menuElement = menuRef.current;
                                const menuChildren = menuElement.children
                                var firstElement = menuChildren[0];
                                
                                console.log(firstElement.classList);
                                if(firstElement.classList.contains("subMenuTrigger")){
                                    var f = firstElement.querySelector('.btn-group .dropdown-item');
                                    firstElement= f;
                                }
                                firstElement?.focus();
                            }
                            
                        }, 150); // Delay for Bootstrap slide transition

                    } else {
                        console.log("Triggered by a mouse click");
                    }
                }}
                
                
            >
                <Stack direction="horizontal" gap={2}>
                    <div className="text-wrap body semibold lh-1">{subMenuButtonTitle}</div>
                    
                    <svg className="" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41L10.59 0Z" fill="white"/>
                    </svg>
                </Stack>
            </Dropdown.Toggle>

            <Dropdown.Menu
                className={getMenuClassNames()}
            >
                <div className="topnav-grid">
                    <div 
                        id={menuId + "-left-column"}
                        className="topnav-column" 
                        ref={menuRef} 
                        onMouseUp={(e)=>{
                            console.log(e);
                        }}
                        onKeyDown={(event)=>{
                            console.log(menuRef, event);
                            if(menu.visible==true && menuRef!=null && menuRef.current!=null){
                                const menuElement = menuRef.current;
                                const menuChildren = menuElement.children
                                var firstElement = menuChildren[0];
                                console.log(firstElement.classList);
                                if(firstElement.classList.contains("subMenuTrigger")){
                                    var f = firstElement.querySelector('.btn-group .dropdown-item');
                                    firstElement= f;
                                }
                                const lastElement = menuChildren[menuChildren.length-1];

                                //var f = menuElement.querySelector('.btn-group .dropdown-item');

                                //(firstElement).focus();

                            
                                
                                if (event.key === KEY_NAME_ESC) {
                                    event.preventDefault();
                                    setMenuVisibility(false,"key");
                                }
                            
                            
                                var keycode = event.keyCode;
                                console.log(event, "keydown", event.key, event.keyCode);

                                if (event.key === "Tab") { //ArrowDown //Arrowup
                                    if (event.shiftKey && document.activeElement === firstElement) {
                                        event.preventDefault();
                                        lastElement.focus();
                                    } 
                                    else if (!event.shiftKey && document.activeElement === lastElement) {
                                        event.preventDefault();
                                        firstElement.focus();
                                    }
                                }
                                
                                //ArrowUp
                                if(keycode==38){
                                    event.preventDefault();
                                    console.log(document.activeElement,firstElement, lastElement);

                                    if (document.activeElement === firstElement) {
                                        event.stopPropagation();
                                        lastElement.focus();
                                    } 
                                }
                                //ArrowDown
                                if(keycode==40){
                                    event.preventDefault();
                                    console.log(document.activeElement,firstElement, lastElement);
                                    
                                    if (document.activeElement === lastElement) {
                                        event.stopPropagation();
                                        firstElement.focus();
                                    } 
                                }
                                //ArrowLeft
                                // if(keycode==37){
                                //     setMenuVisibility(false,"key");
                                //     var sel = document.querySelector("#"+menuId);
                                //     var prev = sel.previousSibling;
                                //     if(prev!=null){
                                //         prev.focus();
                                //     }
                                //     else{
                                //         var childs = sel.parentElement.lastChild;
                                //         childs.focus();
                                //     }
                                // }
                                //ArrowRight
                                // if(keycode==39){
                                //     if(document.activeElement.id!="drop-toggle-subMenu"){
                                //         setMenuVisibility(false,"key");
                                //         var sel = document.querySelector("#"+menuId);
                                //         var next = sel.nextSibling;
                                //         if(next!=null){
                                //             next.focus();
                                //         }
                                //         else{
                                //             var childs = sel.parentElement.firstChild;
                                //             childs.focus();
                                //         }
                                //     }
                                    
                                // };
                                //Escape
                                if(keycode==27){
                                    event.preventDefault();
                                    event.stopPropagation();
                                    setMenuVisibility(false,"key");//setDisplayMenu(false);
                                }
                                //Enter
                                // if(keycode == 13){
                                //     //event.preventDefault();
                                //     //setDisplayMenu(true);
                                //     //hideSubMenu();
                                //     console.log(document.activeElement);
                                // }
                            }
                        }}
                    >
                        {
                            subMenuItems.col1.map((item, index) => {
                                if(item.hasOwnProperty("subMenuKey")==true){

                                    return (
                                        <div className="d-flex flex-row subMenuTrigger" 
                                            
                                        >
                                            <ButtonGroup
                                                
                                            >
                                                <Dropdown.Item 
                                                    as={Link} 
                                                    to={item.link} 
                                                    onKeyDown={handleLinkPress}
                                                    onClick={handleLinkPress}
                                                    onMouseEnter={(e)=>{
                                                        console.log("subMenuTrigger - Dropdown.Item - onMouseEnter" ,e, document.activeElement);
                                                        

                                                        
                                                        
                                                        if(subMenus[item.subMenuKey]?.visible == true){
                                                            clearTimeout(closeSubMenuTimer);
                                                        }
                                                        else{
                                                            if(document.activeElement!=null && document.activeElement.id!="drop-toggle-subMenu"){
                                                                subMenusDispatch({
                                                                    type: ACTIONS.SET_VISIBILITY,
                                                                    subMenuKey: item.subMenuKey,
                                                                    visible: true,
                                                                    trigger: "hover"
                                                                })
                                                            }
                                                            else{
                                                                
                                                            }
                                                            

                                                            
                                                            
                                                            if(e.relatedTarget!=null && e.relatedTarget.id=="drop-toggle-subMenu"){

                                                            }
                                                            else{
                                                                // subMenusDispatch({
                                                                //     type: ACTIONS.SET_VISIBILITY,
                                                                //     subMenuKey: item.subMenuKey,
                                                                //     visible: true,
                                                                //     trigger: "hover"
                                                                // })
                                                            }
                                                            // if(subMenus[item.subMenuKey]?.trigger!="click" && subMenus[item.subMenuKey]?.trigger!="key"){
                                                                
                                                            // }
                                                        }
                                                        
                                                    }}
                                                    onMouseLeave={(e)=>{
                                                        console.log("subMenuTrigger - Dropdown.Item - onMouseLeave" ,e);
                                                        // clearTimeout(closeSubMenuTimer);
                                                        
                                                        // if(e.relatedTarget!=null && e.relatedTarget.id=="drop-toggle-subMenu"){
                                                        //     clearTimeout(closeSubMenuTimer);
                                                        // }
                                                        // else{
                                                            if(subMenus[item.subMenuKey]?.visible==true && subMenus[item.subMenuKey]?.trigger == "hover"){
                                                                var c = getClosest(document.activeElement,"#"+menuId);
                                                                
                                                                if(c!=null && c==false){
                                                                    console.log("topNavSubMenuItem - mouseLeave - timeout");
                                                                    clearTimeout(closeSubMenuTimer);
                                                                    closeSubMenuTimer = setTimeout(() => {
                                                                        subMenusDispatch({
                                                                            type: ACTIONS.SET_VISIBILITY,
                                                                            subMenuKey: item.subMenuKey,
                                                                            visible: false,
                                                                            trigger: "hover"
                                                                        })
                                                                    }, 500);
                                                                }
                                                                // else{
                                                                    
                                                                // }
                                                            }
                                                        // }
                                                        //console.log(e.currentTarget, e.relatedTarget);
                                                        
                                                        
                                                    }}
                                                    {...isCurrentPage(item.link)}
                                                    >
                                                    <div className="topNavSubMenuItem p-0 d-flex flex-row align-items-center">
                                                        <div className="topNavSubMenuItemIcon">{item.icon()}</div>
                                                        <div className="topNavSubMenuItemText">
                                                            <div className="title p-0">{item.title}</div>
                                                            <div className="desc p-0">{item.desc}</div>
                                                        </div>
                                                    </div>
                                                </Dropdown.Item>
                                                <Button
                                                    id="drop-toggle-subMenu" 
                                                    className={"topNavMenuItem nav-link " + (subMenus[item.subMenuKey]?.visible ? "open" : "")}
                                                    data-bs-boundary="viewport" 
                                                    variant=""
                                                    aria-expanded={subMenus[item.subMenuKey]?.visible}
                                                    aria-controls={visibleSubMenu}
                                                    aria-label={subMenus[item.subMenuKey]?.label}
                                                    ref={(node) => {
                                                        const map = subMenuBtnRefs.current;
                                                        
                                                        if (node) {
                                                            map.set(item.subMenuKey, node);
                                                        } else {
                                                            map.delete(item.subMenuKey);
                                                        }
                                                    }}
                                                    onMouseOver={(e)=>{
                                                        console.log("mouseover-", e);
                                                        clearTimeout(closeSubMenuTimer);
                                                    }}
                                                    onClick={(e)=>{
                                                        console.log("drop-toggle-subMenu - onClick", e);

                                                        subMenusDispatch({
                                                            type: ACTIONS.SET_VISIBILITY,
                                                            subMenuKey: item.subMenuKey,
                                                            visible: !subMenus[item.subMenuKey].visible,
                                                            trigger: "click"
                                                        })

                                                        if (e.detail === 0) {
                                                            console.log("drop-toggle-subMenu - onClick","Triggered by keyboard (Enter/Space)");
                                                            
                                                            const timer = setTimeout(() => {
                                                                if(subMenuRef!=null && subMenuRef.current!=null){
                                                                    const subMenuElement = subMenuRef.current;
                                                                    const subMenuChildren = subMenuElement.children
                                                                    const firstSubElement = subMenuChildren[0];
                                                                    firstSubElement?.focus();
                                                                }
                                                            }, 150); // Delay for Bootstrap slide transition

                                                        } else {
                                                            console.log("drop-toggle-subMenu - onClick", "Triggered by a mouse click");
                                                        }
                                                        
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 5 10" fill="none">
                                                        <path d="M0 10L5 5L0 0V10Z" fill="black"/>
                                                    </svg>
                                                </Button>
                                            </ButtonGroup>
                                            
                                            
                                        </div>
                                    )
                                }
                                else{
                                    return (
                                        <Dropdown.Item 
                                            as={Link} 
                                            to={item.link} 
                                            onKeyDown={handleLinkPress} 
                                            onClick={handleLinkPress} 
                                            onMouseEnter={(e)=>{
                                                console.log("Dropdown.Item - NON-sub - onMouseEnter" ,e);
                                                if(visibleSubMenu!=null && subMenus[visibleSubMenu]!=null){
                                                    var menuItem = subMenus[visibleSubMenu];
                                                    console.log(menuItem);
                                                    if(menuItem.trigger=="hover" && menuItem.visible == true){
                                                        clearTimeout(closeSubMenuTimer);

                                                        closeSubMenuTimer = setTimeout(() => {
                                                            subMenusDispatch({
                                                                type: ACTIONS.SET_VISIBILITY,
                                                                subMenuKey: visibleSubMenu,
                                                                visible: false,
                                                                trigger: "hover"
                                                            })
                                                        }, 200)
                                                    }
                                                    
                                                }
                                                
                                            }}
                                            {...isCurrentPage(item.link)}
                                        >
                                            <div className="topNavSubMenuItem p-0 d-flex flex-row align-items-center">
                                                <div className="topNavSubMenuItemIcon">{item.icon()}</div>
                                                <div className="topNavSubMenuItemText">
                                                    <div className="title p-0">{item.title}</div>
                                                    <div className="desc p-0">{item.desc}</div>
                                                </div>
                                            </div>
                                        </Dropdown.Item>
                                    )
                                }
                            })
                        }
                        
                    </div>

                    {
                        subMenus!=null && visibleSubMenu!=null
                        ?   
                            <div 
                                className="topnav-column subMenu-col" 
                                ref={subMenuRef} 
                                id={visibleSubMenu} 
                                aria-label={subMenus[visibleSubMenu].label}
                                onMouseEnter={(e)=>{
                                    clearTimeout(closeMenuTimer);
                                    clearTimeout(closeSubMenuTimer);
                                }}
                                onKeyDown={(event)=>{
                                    const subMenuElement = subMenuRef.current;
                                    const subMenuChildren = subMenuElement.children
                                    const firstSubElement = subMenuChildren[0];
                                    const lastSubElement = subMenuChildren[subMenuChildren.length-1];
                                    
                                    var keycode = event.key;
                                    console.log("keydown", event.key, event);
                                
                                    if (event.key === KEY_NAME_ESC) {
                                        event.preventDefault();
                                        hideSubMenu("key");
                                    }

                                    

                                    if (event.key == "Tab") { //ArrowDown //Arrowup
                                        if (event.shiftKey && document.activeElement === firstSubElement) {
                                            event.preventDefault();
                                            lastSubElement.focus();
                                        } 
                                        else if (!event.shiftKey && document.activeElement === lastSubElement) {
                                            event.preventDefault();
                                            firstSubElement.focus();
                                        }
                                    }
                                    
                                    //ArrowUp
                                    if(keycode=="ArrowUp"){
                                        event.preventDefault();
                                        console.log(document.activeElement,firstSubElement, lastSubElement);
                                        
                                        if (document.activeElement === firstSubElement) {
                                            event.stopPropagation();
                                            lastSubElement.focus();
                                        } 
                                    }
                                    //ArrowDown
                                    if(keycode=="ArrowDown"){
                                        event.preventDefault();
                                        console.log(document.activeElement,firstSubElement, lastSubElement);
                                        
                                        if (document.activeElement === lastSubElement) {
                                            event.stopPropagation();
                                            firstSubElement.focus();
                                        } 
                                    }
                                    //ArrowLeft
                                    if(keycode=="ArrowLeft"){
                                        hideSubMenu("key");
                                    }
                                    //ArrowRight
                                    if(keycode=="ArrowRight"){
                                        
                                    };
                                    //Escape
                                    if(keycode=="Escape"){
                                        event.preventDefault();
                                        event.stopPropagation();
                                        hideSubMenu("key");
                                    }
                                    //Enter
                                    if(keycode == "Enter"){
                                        //event.preventDefault();
                                        //hideSubMenu();
                                    }

                                }}
                            >
                                {(subMenus[visibleSubMenu]).subMenuItems.map((item, index) => (
                                    <Dropdown.Item as={Link} to={item.link} onKeyDown={handleLinkPress} onClick={handleLinkPress} {...isCurrentPage(item.link)}>
                                        <div className="topNavSubMenuItem p-0 d-flex flex-row align-items-center">
                                            <div className="topNavSubMenuItemIcon">{item.icon()}</div>
                                            <div className="topNavSubMenuItemText">
                                                <div className="title p-0">{item.title}</div>
                                                <div className="desc p-0">{item.desc}</div>
                                            </div>
                                        </div>
                                    </Dropdown.Item>
                                ))}
                            </div>
                        :
                            null
                    }
                    
                </div>
            </Dropdown.Menu>
        </Dropdown>

   
  );
}

export default NavMenu;